import React, { useEffect, useState } from "react";

// Official isotype paths (naguara-isotipo-ojos-*.svg). Inlined — never redrawn.
const EYE_PATHS = [
  "M 201.640625 486.992188 C 201.640625 498.582031 193.765625 507.980469 184.050781 507.980469 C 174.339844 507.980469 166.464844 498.582031 166.464844 486.992188 C 166.464844 475.398438 174.339844 466 184.050781 466 C 193.765625 466 201.640625 475.398438 201.640625 486.992188 Z M 201.640625 486.992188 ",
  "M 141.5 493.800781 C 141.5 507.273438 134.898438 518.195312 126.75 518.195312 C 118.605469 518.195312 112 507.273438 112 493.800781 C 112 480.328125 118.605469 469.40625 126.75 469.40625 C 134.898438 469.40625 141.5 480.328125 141.5 493.800781 Z M 141.5 493.800781 ",
];

// Two official eyes that blink together via a pure CSS animation (see index.css).
export const BlinkingEyes = ({ variant = "chocolate", width = 48, footer = false, className = "", testId }) => {
  const [reduced, setReduced] = useState(false);
  const fill = variant === "beige" ? "#E1DBC3" : "#422D28";
  const height = Math.round((width * 80) / 125);

  useEffect(() => {
    const m = window.matchMedia("(prefers-reduced-motion: reduce)");
    setReduced(m.matches);
    const onChange = (e) => setReduced(e.matches);
    m.addEventListener?.("change", onChange);
    return () => m.removeEventListener?.("change", onChange);
  }, []);

  return (
    <svg
      width={width}
      height={height}
      viewBox="95 450 125 80"
      aria-hidden="true"
      data-testid={testId}
      data-reduced-motion={reduced ? "true" : "false"}
      className={`mascot-eyes${footer ? " mascot-eyes--footer" : ""} ${className}`}
      style={{ display: "block", overflow: "visible" }}
    >
      {EYE_PATHS.map((d, i) => (
        <path key={i} className="mascot-eye" d={d} fill={fill} />
      ))}
    </svg>
  );
};

export default BlinkingEyes;
